import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AppProviders } from "./hooks/useAuth";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AppProviders>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </AppProviders>
    </I18nextProvider>
  );
}

export default App;